// src/redux/adminMemberApi.js
import { apiSlice } from "./apiSlice";

export const adminMemberApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 회원 상세 조회
        getMemberDetail: build.query({
            query: (memberId) => ({
                url: `/api/admin/member/v1/${memberId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 회원 정보 수정
        updateMember: build.mutation({
            query: ({ memberId, body }) => ({
                url: `/api/admin/member/v1/${memberId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 회원 지역 설정
        updateMemberArea: build.mutation({
            query: ({ memberId, body }) => ({
                url: `/api/admin/member/v1/${memberId}/area`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 회원 지역 상세 조회
        getMemberAreaDetail: build.query({
            query: (memberId) => ({
                url: `/api/admin/member/v1/${memberId}/area`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 비밀번호 초기화
        memberResetPassword: build.mutation({
            query: (memberId) => ({
                url: `/api/admin/member/v1/${memberId}/password_reset`,
                method: "put",
                headers: { token: true },
            }),
        }),

        // 회원 상태 변경
        updateMemberStatus: build.mutation({
            query: ({ memberId, body }) => ({
                url: `/api/admin/member/v1/${memberId}/member_status`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 회원 별칭 설정
        updateMemberAlias: build.mutation({
            query: ({ memberId, body }) => ({
                url: `/api/admin/member/v1/${memberId}/alias`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),

        // 가입 승인
        confirmJoin: build.mutation({
            query: (memberId) => ({
                url: `/api/admin/member/v1/${memberId}/join/confirm`,
                method: "put",
                headers: { token: true },
            }),
        }),

        // 회원 리스트 조회
        getMemberList: build.query({
            query: (params) => ({
                url: "/api/admin/member/v1",
                method: "get",
                params,
                headers: { token: true },
            }),
        }),

        // 오더 회원 리스트 조회
        getOrderMemberList: build.query({
            query: (params) => ({
                url: "/api/admin/member/v1/order",
                method: "get",
                params,
                headers: { token: true },
            }),
        }),

        // 회원 삭제
        deleteMember: build.mutation({
            query: (memberId) => ({
                url: `/api/admin/member/v1/${memberId}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    useGetMemberDetailQuery,
    useLazyGetMemberDetailQuery,
    useUpdateMemberMutation,
    useUpdateMemberAreaMutation,
    useGetMemberAreaDetailQuery,
    useMemberResetPasswordMutation,
    useUpdateMemberStatusMutation,
    useUpdateMemberAliasMutation,
    useConfirmJoinMutation,
    useGetMemberListQuery,
    useLazyGetMemberListQuery,
    useGetOrderMemberListQuery,
    useLazyGetOrderMemberListQuery,
    useDeleteMemberMutation,
} = adminMemberApi;
